<dx-scroll-view class="view-wrapper-scroll">
  <div class="view-wrapper">
    <toolbar-analytics
      titleText="Dashboard"
      [panelItems]="analyticsPanelItems"
      [selectedItems]="[5]"
      (selectionChanged)="selectionChange($event)"
    >
    </toolbar-analytics>

    <div class="cards grey">
      <opportunities-ticker [data]="opportunities"></opportunities-ticker>
      <revenue-total-ticker [data]="sales"></revenue-total-ticker>
      <conversion-ticker></conversion-ticker>
      <leads-ticker></leads-ticker>
    </div>

    <div class="cards">
      <revenue-card [data]="sales"></revenue-card>
      <conversion-card [data]="opportunities"></conversion-card>
      <revenue-analysis-card [data]="salesByState"></revenue-analysis-card>
      <revenue-snapshot-card [data]="salesByCategory"></revenue-snapshot-card>
    </div>
  </div>
</dx-scroll-view>
<dx-load-panel
  container=".view-wrapper"
  [position]="{ of: '.content' }"
  [visible]="isLoading"
  [showPane]="true"
></dx-load-panel>
